import {useEffect} from 'react';
import withRouter from '@/components/withRouter';
import {isMobile} from 'react-device-detect';
import GrtLoading from '@/components/GrtLoading/GRTLoading';

const ShareSameFullLink = (props) => {
    let mobile = props.searchParams.get('mobile'),
        web = props.searchParams.get('web');
    //判断pc还是移动端，跳转到对应页面
    const handleHref = () => {
        let href = isMobile ? mobile : web;
        window.location.replace(href);
    };

    useEffect(() => {
        if (mobile || web) handleHref();
    }, [mobile, web]);

    return (
        <div>
            <GrtLoading></GrtLoading>
        </div>
    );
};
export default withRouter(ShareSameFullLink);
